import { useSettings } from '@/data/Settings';
import { EmailDomainValidationResult } from '@/data/types/EmailDomainValidation';
import { transactionsValidateEmail } from 'integration/generated/transactions';
import { useCallback } from 'react';

export const useEmailDomainValidation = () => {
	const { settings } = useSettings();
	const storeId = settings?.storeId;

	const validateEmailFetcher = useCallback(
		async (email: string, signal?: AbortSignal): Promise<EmailDomainValidationResult> => {
			if (!storeId) {
				return null;
			}
			try {
				const data = await transactionsValidateEmail(true).validateEmail(
					storeId,
					{ email },
					{ signal }
				);
				return data?.response?.valid === true;
			} catch (error) {
				const status = (error as { status?: number })?.status;
				if (status === 400) {
					return false;
				}
				return null;
			}
		},
		[storeId]
	);

	return { validateEmailFetcher };
};
